export default __webpack_public_path__ + "static/2-464ac9e873f12f1f465464d6d3929aa8.jpg";